'use client';

import { useMenu } from '@/context/MenuContext';
import { motion, AnimatePresence } from 'framer-motion';
import { useEffect, useState } from 'react';
import { Squeeze as Hamburger } from 'hamburger-react';

function FixedHamburgerIcon() {
  const { mobileMenuOpen, setMobileMenuOpen, desktopMenuOpen, setDesktopMenuOpen } = useMenu();
  const [showFixedMenuIcon, setShowFixedMenuIcon] = useState(false);

  // Handle scroll detection
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      // Show icon if scrolled more than 40px
      setShowFixedMenuIcon(scrollY > 40);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Click handler for the button
  const handleClick = () => {
    if (window.innerWidth >= 1024) {
      setDesktopMenuOpen(!desktopMenuOpen);
    } else {
      setMobileMenuOpen(!mobileMenuOpen);
    }
  };

  const bounceScale = {
    hidden: { opacity: 0, scale: 0.5 },
    visible: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.5 },
  };

  return (
    <AnimatePresence>
      {(showFixedMenuIcon || mobileMenuOpen) && (
        <>
          <motion.button
            key='mobile-hamburger-icon'
            className={`sm:hidden fixed top-4 right-4 z-[999] transition-colors duration-500 ${!mobileMenuOpen ? 'bg-brand-600 text-dark-900 stroke-dark-900 shadow-lg' : 'bg-dark-900 text-white shadow-none'} text-white rounded-full p-4 cursor-pointer`}
            onClick={handleClick}
            initial='hidden'
            animate='visible'
            exit='exit'
            variants={bounceScale}
            transition={{ type: 'spring', stiffness: 300, damping: 15 }}
          >
            <Hamburger size={24} toggled={mobileMenuOpen} toggle={setMobileMenuOpen} />
          </motion.button>

          <motion.button
            key='desktop-hamburger-icon'
            className={`hidden sm:block fixed sm:top-8 sm:right-8 z-[999] transition-colors duration-500 ${!desktopMenuOpen ? 'bg-yellow-600 text-dark-900 shadow-lg' : 'bg-dark-900 text-white shadow-none'} rounded-full sm:p-6  cursor-pointer`}
            onClick={handleClick}
            initial='hidden'
            animate='visible'
            exit='exit'
            variants={bounceScale}
            transition={{ type: 'spring', stiffness: 300, damping: 15 }}
          >
            <Hamburger size={32} toggled={desktopMenuOpen} toggle={setDesktopMenuOpen} />
          </motion.button>
        </>
      )}
    </AnimatePresence>
  );
}

export default FixedHamburgerIcon;
